import * as defs from './defs';

export class TaxCalculatorMW extends defs.TaxCalculatorBase {
  public getDepositTax = (req: defs.TaxRequest): defs.TaxResponse => {
    // deposit tax - 0;
    return {
      rawTaxAmount: 0,
      taxAmount: 0,
      originalAmount: req.totalAmount,
      amountAfterTax: req.totalAmount,
      taxedAmount: 0,
    };
  };

  public getWithdrawTax = (req: defs.TaxRequest): defs.TaxResponse => {
    // withdraw tax - 0
    return {
      rawTaxAmount: 0,
      taxAmount: 0,
      originalAmount: req.totalAmount,
      amountAfterTax: req.totalAmount,
      taxedAmount: 0,
    };
  };

  public getSportsbookBetTax = (req: defs.TaxRequest): defs.TaxResponse => {
    // sport bet tax - 0
    return {
      rawTaxAmount: 0,
      taxAmount: 0,
      originalAmount: req.totalAmount,
      amountAfterTax: req.totalAmount,
      taxedAmount: 0,
    };
  };

  public getSportsbookWinTax = (req: defs.TaxRequest): defs.TaxResponse => {
    // sport win tax: 5% of winnings above K100,000
    // winnings = (ticketWin - ticketBet)
    // 2025-12-05: all winnings are taxed (removed K100,000 threshold): https://boongaming.atlassian.net/browse/AFK-1542
    let taxedAmount = req.totalAmount - (req.notTaxableAmount ?? 0);
    let rawTaxAmount = 0;
    let taxAmount = 0;
    if (taxedAmount > 0) {
      //rawTaxAmount = 0.05 * taxedAmount;
      // 2025-08-20: tax changed to 10%: https://boongaming.atlassian.net/browse/AFK-1452
      // 2025-12-05: tax changed to 15%: https://boongaming.atlassian.net/browse/AFK-1542
      rawTaxAmount = 0.15 * taxedAmount;
      taxAmount = Math.round(rawTaxAmount);
    } else {
      taxedAmount = 0;
    }

    return {
      rawTaxAmount,
      taxAmount,
      originalAmount: req.totalAmount,
      amountAfterTax: req.totalAmount - taxAmount,
      taxedAmount,
    };
  };
}
